import React from "react";
import { Button } from "../ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import "../customerFacing/customer.css";
import Nav from "../components/Nav"

// Sample Product Data
const productsPopular = [
  {
    id: 1,
    name: "Course on Digital Art",
    price: "$29.99",
    description: "Learn the fundamentals of digital art with this beginner-friendly course.",
    imagePath: "/images/807cb630-f148-4ed3-8d89-d4dbf753f3a0-planner.jpg"
  },
  {
    id: 2,
    name: "Premium Photoshop Templates",
    price: "$19.99",
    description: "High-quality Photoshop templates for creative projects.",
    imagePath: "/images/8518956e-74c9-4fb2-95f2-ced8a43c8256-mount.jpg"
  },
  {
    id: 3,
    name: "Creative Kid's Printable Designs",
    price: "$9.99",
    description: "Fun and educational printables for children of all ages.",
    imagePath: "/images/fadb4f67-b64d-41bf-8843-da56482b792d-webdev.jpg"
  }
];

const productsNew = [
  {
    id: 1,
    name: "Illustrator Brush Pack",
    price: "$14.99",
    description: "A set of custom brushes for Adobe Illustrator to elevate your designs.",
    imagePath: "/images/brushes.avif",
  },
  {
    id: 2,
    name: "Complete Guide to WordPress",
    price: "$59.99",
    description: "Master WordPress with this comprehensive course and guide.",
    imagePath: "/images/make-a-wordpress-website.png",

  },
  {
    id: 3,
    name: "E-commerce Setup Guide",
    price: "$79.99",
    description: "Comprehensive guide to setting up and running an e-commerce store.",
    imagePath: "/images/1675349943774.jpeg",

  },
];

export default function HomePage() {
  return (
    <>
        <Nav/>
        <main className="space-y-12 p-10">
        <HeroSection />
        <FeaturedBanner />
        <SecondHeroSection />
        <ThirdHeroSection />
        <Heading />
        <ProductGridSection title="Most Popular" products={productsPopular} />
        <ProductGridSection title="Newest" products={productsNew} />
        <TestimonialsSection />
        <NewsletterSection />
        <CategoryHighlights />
      </main>
      <Footer />
    </>
  );
}


function HeroSection() {
  // Smooth scroll function
  const handleScroll = () => {
    const targetSection = document.getElementById("custom-h1");
    targetSection?.scrollIntoView({
      behavior: "smooth", // Smooth scrolling
      block: "start", // Align to the top of the section
    });
  };

  return (
    <section className="flex flex-col lg:flex-row items-center justify-between bg-white text-card-foreground py-12 px-6 lg:px-12 rounded-[25px]">
      {/* Left Content */}
      <div className="max-w-lg space-y-6">
        <h1 className="text-4xl lg:text-5xl font-bold">
          Your Digital World, Your Style – Only at Nuvia
        </h1>
        <p className="text-lg">
          Unlock a universe of downloadable content! From educational courses to printable designs, find everything you need to learn, create, and explore—instantly accessible at your fingertips.
        </p>
        <Button asChild>
          <button
            className="rounded-[16px] text-white bg-blue-500 hover:bg-blue-600"
            onClick={handleScroll} // Trigger smooth scroll on click
          >
            Shop Now
          </button>
        </Button>
      </div>

      {/* Right Content (GIF or Image) */}
      <div className="mt-8 sm:mt-[4rem] lg:mt-0 lg:ml-12 flex items-center justify-center w-full lg:w-auto">
        <img
          src="/images/nap-creativityfacts.jpg"
          alt="Virelo's Top Picks"
          className="custom-image rotate-0"
        />
      </div>
    </section>
  );
}

function FeaturedBanner() {
  return (
    <section className="bg-gradient-to-r from-pink-600 via-red-300 to-orange-200 dark:bg-gradient-to-r from-pink-300 via-red-300 to-orange-300 p-6 rounded-[25px] flex flex-col sm:flex-row justify-between items-center">
      <div>
        <h2 className="text-2xl font-bold text-white">Special Offer: 20% Off</h2>
        <p className="text-white">Shop now and save big on select products!</p>
      </div>
      <Button asChild>
        <Link to="/products" className="text-white hover:text-gray-200 shadow-lg p-3 rounded-[17px] border-2 custom-link">
          Explore Deals
        </Link>
      </Button>
    </section>
  );
}


function SecondHeroSection() {
  return (
    <section className="flex flex-col lg:flex-row items-center justify-between bg-white text-card-foreground py-12 px-6 lg:px-12 rounded-[25px]">
       {/* Right Content */}
       <div className="max-w-lg space-y-6">
        <h1 className="text-4xl lg:text-5xl font-bold">
          Your Next Project Starts Here
        </h1>
        <p className="text-lg">
          At Nuvia, we make your creative process effortless with a vast library of ready-to-download digital resources. From premium courses to unique templates, find the perfect tools to bring your ideas to life.<br/><br/>
          <strong>Explore, download, and achieve more with just a click!</strong>
        </p>
        <Button asChild>
          <Link className="rounded-[16px]" to="/products">
            Get Started
          </Link>
        </Button>
      </div>
      {/* Left Content (GIF or Image) */}
      <div className="mt-8 lg:mt-0 lg:ml-12 flex items-center justify-center w-full lg:w-auto">
        <img
          src="/images/create.jpg"
          alt="Unlock Creativity with Nuvia"
          className="custom-image  rotate-0"
        />
      </div>

     
    </section>
  );
}

function ThirdHeroSection() {
  return (
    <section className="flex flex-col lg:flex-row items-center justify-between bg-white py-12 px-6 lg:px-12 rounded-[25px]">
       {/* Right Content (Image or Icon) */}
       <div className="mt-8 lg:mt-0 lg:ml-12 flex items-center justify-center w-full lg:w-auto">
        <img
          src="/images/victory2.jpg"
          alt="Membership Benefits"
          className="custom-image  rotate-0"
        />
      </div>
      {/* Left Content */}
      <div className="max-w-lg space-y-6">
        <h1 className="text-4xl lg:text-5xl font-bold text-gray-800">
          Empower Your Journey with Nuvia Pro
        </h1>
        <p className="text-lg text-gray-800">
          Get access to exclusive resources, premium support, and personalized recommendations tailored for your goals.
        </p>
        <Button asChild>
          <Link to="/go-pro" className="rounded-[16px] bg-yellow-500 text-white px-6 py-3 hover:bg-orange-600 transition-colors">
            Go Pro Now!
          </Link>
        </Button>
      </div>
    </section>
  );
}

function Heading(){
  return (
    <div>
      <br />
      <h1 className="font-extrabold text-center mb-10 custom-h1" id="custom-h1">
  Discover What&apos;s Trending and New
</h1>
    <br/>
    </div>
  )
}

function ProductGridSection({ title, products }) {
  return (
    <section>
      <header className="flex justify-between items-center mb-6">
        <h2 className="text-[40px] font-bold">{title}</h2>
        <Link to="/products">
          <Button variant="link">
            Browse All <ArrowRight className="ml-1 h-4 w-4" />
          </Button>
        </Link>
      </header>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {products.map((product) => (
          <div key={product.id} className="flex overflow-hidden flex-col rounded-[25px] shadow-lg hover:shadow-xl transition-shadow duration-300 border-none">
            {/* Card Content */}
            <div className="relative w-full h-auto aspect-video">
              <img src={product.imagePath} alt={product.name} className="w-full h-auto object-cover" />
            </div>
            <div className="flex flex-col space-y-1.5 p-6">
              <h3 className="text-2xl font-semibold leading-none tracking-tight">{product.name}</h3>
              <p className="text-sm text-muted-foreground">{product.price}</p>
            </div>
            <div className="flex-grow p-6 pt-0">
              <p className="line-clamp-4">{product.description}</p>
            </div>
            <div className="flex items-center p-6 pt-0">
              <Button asChild size="lg" className="w-full">
                <Link to={`/products/purchase/${product.id}`}>Purchase</Link>
              </Button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function CategoryHighlights() {
  const categories = [
    { name: "Stock Photos", description: "High-quality stock photos for creative projects" },
    { name: "Online Courses", description: "Learn new skills with expert-led online courses" },
    { name: "Printables",description: "Download and print planners, templates, and more" },
    { name: "Kids", description: "Fun and educational products for kids" },
    { name: "E-books", description: "Discover a wide range of e-books and guides on topics from personal development to specialized skills" },
    { name: "Software & Tools", description: "Get access to useful software and productivity tools" },
  ];

  return (
    <section className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6">
      {categories.map((category) => (
        <div
          key={category.name}
          className="p-3 bg-white rounded-[25px] text-center shadow-lg transition-all duration-300 hover:scale-105 border-4 border-mute"
        >
          <h3 className="text-2xl font-bold text-black mb-2">{category.name}</h3>
          <p className="text-sm text-gray-600 mb-4">{category.description}</p>
          <Button
            asChild
            className="text-white bg-blue-600 hover:bg-blue-700 transition-colors duration-300 py-2 px-6 rounded-lg"
          >
            <Link to="/products">Explore</Link>
          </Button>
        </div>
      ))}
    </section>
  );
}

function TestimonialsSection() {
  const testimonials = [
    {
      quote: "I've been downloading digital products from here for months, and it’s transformed the way I shop online. The process is seamless, the content is top-tier, and I’ve never had any issues with downloads. It’s my go-to for all things digital!",
      author: "Sophia Johnson",
    },
    {
      quote: "As someone who loves finding high-quality digital content, I was impressed by what this store offers. The variety is unmatched, and the customer support is fantastic. I highly recommend it to anyone looking for great digital downloads!",
      author: "Mark Davis",
    },
    {
      quote: "I used to hesitate about purchasing digital products online, but this store has changed that. Everything I’ve downloaded has been exactly as promised and at great prices. I’ll definitely return for more in the future!",
      author: "Olivia Martinez",
    },
  ];

  return (
    <section className="p-12 bg-white rounded-lg">
      <h2 className="text-3xl font-semibold text-center text-gray-800 mb-8">What Our Customers Say</h2>
      <div className="flex flex-col lg:flex-row lg:space-x-8 space-y-8 lg:space-y-0">
        {testimonials.map((testimonial, i) => (
          <div
            key={i}
            className="flex-1 p-6 border-l-4 border-gradient-to-r from-blue-500 via-indigo-600 to-blue-700 bg-white shadow-md rounded-lg"
          >
            <p className="text-lg text-black italic">{testimonial.quote}</p>
            <footer className="mt-4 text-sm text-transparent bg-clip-text bg-gradient-to-r from-blue-500 via-indigo-600 to-blue-700">
              - {testimonial.author}
            </footer>
          </div>
        ))}
      </div>
    </section>
  );
}


function NewsletterSection() {
  return (
    <section className="p-8 bg-white rounded-lg text-center space-y-6">
      <h2 className="text-3xl font-semibold text-gray-900">Stay in the Loop!</h2>
      <p className="text-lg text-gray-600">
        Dont miss out on the latest tech trends and exclusive deals. Subscribe now!
      </p>
      <form className="flex justify-center space-x-4">
        <input
          type="email"
          placeholder="Enter your email"
          className="p-3 w-64 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors"
        />
        <Button type="submit" className="bg-blue-600 text-white px-6 py-3 rounded-md hover:bg-blue-700 transition-colors">
          Subscribe
        </Button>
      </form>
    </section>
  );
}

function Footer() {
  return (
    <footer className="bg-gradient-to-r from-orange-400 via-red-500 to-pink-500 text-white text-center rounded-t-[25px] mt-12 shadow-lg w-full py-6">
    <div className="max-w-7xl mx-auto px-6">
      <p className="text-sm sm:text-base">
        &copy; {new Date().getFullYear()} Nuvia. All rights reserved. This website is for demonstration purposes only!
      </p>
      <div className="mt-4">
        <span className="text-sm sm:text-base hover:underline cursor-pointer">
          Privacy Policy
        </span>
        <span className="mx-2">|</span>
        <span className="text-sm sm:text-base hover:underline cursor-pointer">
          Terms & Conditions
        </span>
      </div>
    </div>
  </footer>
  
  );
}
